import { render, staticRenderFns } from "./PointCloudmap.vue?vue&type=template&id=5814c686&scoped=true&"
import script from "./PointCloudmap.vue?vue&type=script&lang=js&"
export * from "./PointCloudmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5814c686",
  null
  
)

export default component.exports